// extracted by mini-css-extract-plugin
export default {"darkNavbarColorModeToggle":"darkNavbarColorModeToggle_Q0Zn"};